type GrossPriceCalculator = (priceInUsd: number) => number;

const priceCalculator = {
    toUsd: (priceInCents: number): number => priceInCents / 100,

    toCents: (priceInUsd: number): number => priceInUsd * 100,

    // grossPriceCalculator expects dollars
    grossPriceInCents: (priceInCents: number, grossPriceCalculator: GrossPriceCalculator): number =>
        priceCalculator.toCents(grossPriceCalculator(priceCalculator.toUsd(priceInCents))),
};

export default priceCalculator;
